(() => {
  const isHomePath = window.location.pathname === "/" || window.location.pathname === "";
  const staleHomepage = isHomePath && document.querySelector(".supercat-hybrid-stat-page") && !document.querySelector(".sc-prey-gap-page");
  if (!staleHomepage) return;

  fetch(`${window.location.origin}/?section_id=prey-hydration-product-section&stale_homepage_rescue=${Date.now()}`, {
    credentials: "same-origin",
    headers: { "Cache-Control": "no-cache" }
  })
    .then((response) => {
      if (!response.ok) throw new Error("Section render failed");
      return response.text();
    })
    .then((html) => {
      const container = document.createElement("div");
      container.innerHTML = html;
      const productSection = container.querySelector("#shopify-section-prey-hydration-product-section");
      const staleSection = document.querySelector("#shopify-section-hybrid-stat-supercat-blue");
      if (!productSection || !staleSection) return;

      staleSection.replaceWith(productSection);
      document.documentElement.classList.remove("supercat-page-live");
      document.documentElement.classList.add("supercat-prey-gap-live");

      productSection.querySelectorAll("script[src]").forEach((script) => {
        if (document.querySelector(`script[src="${script.src}"]`)) return;
        const replacement = document.createElement("script");
        replacement.src = script.src;
        replacement.defer = true;
        replacement.dataset.preyHydrationFallback = "true";
        document.body.appendChild(replacement);
      });
    })
    .catch(() => {});
})();

const hideThemeChrome = () => {
  if (!document.querySelector(".supercat-hybrid-stat-page")) return;
  document.documentElement.classList.add("supercat-page-live");
  const headerGroup = document.querySelector("#header-group");
  if (headerGroup) headerGroup.style.setProperty("display", "none", "important");
  Array.from(document.body.children).forEach((child) => {
    if (child.tagName === "FOOTER" && !child.closest(".supercat-hybrid-stat-page")) {
      child.style.setProperty("display", "none", "important");
    }
  });
};
hideThemeChrome();
document.addEventListener("DOMContentLoaded", hideThemeChrome);
window.addEventListener("load", hideThemeChrome);

document.querySelectorAll(".gallery-panel").forEach((gallery) => {
  const dots = Array.from(gallery.querySelectorAll(".dot"));
  const thumbs = Array.from(gallery.querySelectorAll(".slot-thumb[data-slide]"));
  const slides = Array.from(gallery.querySelectorAll(".gallery-slide"));

  const setActiveSlide = (index) => {
    slides.forEach((slide, slideIndex) => slide.classList.toggle("active", slideIndex === index));
    dots.forEach((dot) => dot.classList.toggle("active", Number(dot.dataset.slide) === index));
    thumbs.forEach((thumb) => thumb.classList.toggle("active", Number(thumb.dataset.slide) === index));
  };

  [...dots, ...thumbs].forEach((control) => {
    control.addEventListener("click", () => {
      const index = Number(control.dataset.slide);
      if (Number.isNaN(index)) return;
      setActiveSlide(index);
    });
  });
});

const moneyFormatter = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });
const formatCents = (cents) => moneyFormatter.format((Number(cents) || 0) / 100);

const setProperty = (form, key, value) => {
  const input = form.querySelector(`[data-sc-property="${key}"]`);
  if (input) input.value = value;
};

const selectedOfferCard = (form) => form.querySelector(".offer-card.selected, .offer-card input:checked")?.closest(".offer-card");
const selectedPurchaseType = (form) => form.querySelector('input[name="purchase_option"]:checked')?.value || "subscription";

const updateOfferForm = (form) => {
  const card = selectedOfferCard(form);
  if (!card) return;

  const isSubscription = selectedPurchaseType(form) === "subscription";
  const sellingPlanInput = form.querySelector("[data-sc-selling-plan]");
  const currentPrice = form.closest(".shopify-product-box")?.querySelector("[data-sc-current-price]");
  const currentCompare = form.closest(".shopify-product-box")?.querySelector("[data-sc-current-compare]");
  const submit = form.querySelector(".product-submit");
  const cardPrice = Number(isSubscription ? card.dataset.subscriptionPrice : card.dataset.oneTimePrice);
  const compareAt = Number(card.dataset.compareAt);
  const subcopy = isSubscription ? card.dataset.subscriptionSubcopy : card.dataset.oneTimeSubcopy;
  const purchaseLabel = isSubscription ? "Subscribe & Save" : "One-Time Purchase";
  const delivery = isSubscription ? card.dataset.delivery : "One-time purchase";

  form.querySelectorAll(".purchase-option").forEach((option) => {
    const input = option.querySelector('input[name="purchase_option"]');
    option.classList.toggle("selected", input?.checked);
  });

  form.querySelectorAll(".offer-card").forEach((item) => {
    const input = item.querySelector('input[name="id"]');
    item.classList.toggle("selected", item === card);
    if (input) input.checked = item === card;
    const itemPrice = Number(isSubscription ? item.dataset.subscriptionPrice : item.dataset.oneTimePrice);
    const itemCompare = Number(item.dataset.compareAt);
    const itemSubcopy = isSubscription ? item.dataset.subscriptionSubcopy : item.dataset.oneTimeSubcopy;
    const priceNode = item.querySelector("[data-sc-card-price]");
    const compareNode = item.querySelector("[data-sc-card-compare]");
    const subcopyNode = item.querySelector("[data-sc-card-subcopy]");
    if (priceNode) priceNode.textContent = formatCents(itemPrice);
    if (compareNode) compareNode.textContent = formatCents(itemCompare);
    if (subcopyNode) subcopyNode.textContent = itemSubcopy || "";
  });

  if (sellingPlanInput) {
    sellingPlanInput.disabled = !isSubscription;
    sellingPlanInput.value = isSubscription ? card.dataset.sellingPlanId || "" : "";
  }
  if (currentPrice) currentPrice.textContent = formatCents(cardPrice);
  if (currentCompare) currentCompare.textContent = formatCents(compareAt);
  if (submit && !submit.disabled) {
    submit.textContent = isSubscription ? "Add To Cart - Subscribe & Save 15%" : "Add To Cart - One-Time Purchase";
  }

  setProperty(form, "purchase_type", purchaseLabel);
  setProperty(form, "boxes", card.dataset.boxLabel || "");
  setProperty(form, "delivery", delivery);
  setProperty(form, "compare_at_unit", String(compareAt || cardPrice));
  setProperty(form, "savings_rate", card.dataset.savingsRate || "");
};

document.querySelectorAll(".shopify-product-form").forEach((form) => {
  form.addEventListener("change", (event) => {
    const purchaseInput = event.target.closest('input[name="purchase_option"]');
    const variantInput = event.target.closest('input[name="id"]');
    if (purchaseInput) {
      purchaseInput.closest(".purchase-toggle")?.querySelectorAll(".purchase-option").forEach((option) => {
        const input = option.querySelector('input[name="purchase_option"]');
        option.classList.toggle("selected", input?.checked);
      });
    }
    if (variantInput) {
      form.querySelectorAll(".offer-card").forEach((card) => card.classList.toggle("selected", card.contains(variantInput)));
    }
    updateOfferForm(form);
  });
  form.addEventListener("click", (event) => {
    const purchaseOption = event.target.closest(".purchase-option");
    if (purchaseOption) {
      const input = purchaseOption.querySelector('input[name="purchase_option"]');
      if (input) input.checked = true;
    }
    const card = event.target.closest(".offer-card");
    if (card) {
      const input = card.querySelector('input[name="id"]');
      if (input && !input.disabled) input.checked = true;
      form.querySelectorAll(".offer-card").forEach((item) => item.classList.toggle("selected", item === card));
    }
    if (purchaseOption || card) updateOfferForm(form);
  });
  updateOfferForm(form);
});

document.querySelectorAll(".product-accordion-list").forEach((list) => {
  const accordions = Array.from(list.querySelectorAll(".product-accordion"));

  const setOpenAccordion = (selectedAccordion) => {
    accordions.forEach((item) => {
      item.open = item === selectedAccordion;
    });
  };

  accordions.forEach((accordion) => {
    const summary = accordion.querySelector("summary");

    const activateAccordion = (event) => {
      event.preventDefault();
      if (accordion.open) {
        accordion.open = false;
        return;
      }
      setOpenAccordion(accordion);
    };

    if (summary) {
      summary.addEventListener("click", activateAccordion);
      summary.addEventListener("keydown", (event) => {
        if (event.key !== "Enter" && event.key !== " ") return;
        activateAccordion(event);
      });
    }

    accordion.addEventListener("toggle", () => {
      if (!accordion.open) return;

      accordions.forEach((item) => {
        if (item !== accordion) item.open = false;
      });
    });
  });
});

document.querySelectorAll(".sc-menu").forEach((menu) => {
  menu.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener("click", (event) => {
      const target = document.querySelector(link.getAttribute("href"));
      if (target) {
        event.preventDefault();
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
      menu.open = false;
    });
  });
});

document.addEventListener("click", (event) => {
  document.querySelectorAll(".sc-menu[open]").forEach((menu) => {
    if (!menu.contains(event.target)) menu.open = false;
  });
});

document.addEventListener("keydown", (event) => {
  if (event.key !== "Escape") return;
  document.querySelectorAll(".sc-menu[open]").forEach((menu) => {
    menu.open = false;
  });
});

document.addEventListener("click", (event) => {
  if (event.defaultPrevented) return;
  const link = event.target.closest('a[href^="#"]');
  if (!link) return;
  const target = document.querySelector(link.getAttribute("href"));
  if (!target) return;
  event.preventDefault();
  target.scrollIntoView({ behavior: "smooth", block: "start" });
});

const updateSticky = () => {
  document.body.classList.toggle("show-sticky", window.scrollY > 900);
};
window.addEventListener("scroll", updateSticky, { passive: true });
updateSticky();
